import { createFileRoute } from '@tanstack/react-router'
import InstallationMetrics from "@/views/installation-metrics";

export const Route = createFileRoute(
  '/_authenticated/_staff/_with_location_switcher/engineering-charts',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <InstallationMetrics />
}
